// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","submenu":"_3TigH","item":"_1nWcF","label":"_2uMF8","landingPage":"_3BkOZ","selected":"toTom"};